export const populationChartDataActions = {
  populatePopulationIncidencePrevalenceChartData:
    "POPULATE_POPULATION_INCIDENCE_PREVALENCE_CHART_DATA",
  populationIncidencePrevalenceChartDataLoading:
    "DATA_POPULATION_INCIDENCE_PREVALENCE_CHART_LOADING",
  populationIncidencePrevalenceChartDataLoadError:
    "DATA_POPULATION_INCIDENCE_PREVALENCE_CHART_LOAD_ERROR"
};
